export const SPEND_SOURCES = [
	{ value: 'google-network', label: 'Google Network' },
	{ value: 'meta', label: 'Meta' },
];
